import request from '@/utils/httpRequest'

// 图片列表
export function getPictureList (data) {
  return request({
    url: '/picture/list',
    method: 'post',
    data
  })
}
// 删除
export function setPictureDelete (data) {
  return request({
    url: '/picture/delete',
    method: 'post',
    data
  })
}
// 编辑获取详情
export function getPictureEdit (data) {
  return request({
    url: '/picture/get',
    method: 'post',
    data
  })
}
// 保存图片
export function setPictureSaveOrUpdate (data) {
  return request({
    url: '/picture/saveOrUpdate',
    method: 'post',
    data
  })
}
// 等级
export function getSupplierLevel (data) {
  return request({
    url: '/supplier-level/list',
    method: 'post',
    data
  })
}
// 图片上传长期有效，只能上传固定图片
// export function setFileUpload (data) {
//   return request({
//     url: '/file/uploadLongTimeMultipartFile',
//     method: 'post',
//     data
//   })
// }


// 图片列表
export function getStyleList (data) {
  return request({
    url: '/style/list',
    method: 'post',
    data
  })
}
// 删除
export function setStyleDelete (data) {
  return request({
    url: '/style/delete',
    method: 'post',
    data
  })
}
// 编辑获取详情
export function getStyleEdit (data) {
  return request({
    url: '/style/get',
    method: 'post',
    data
  })
}
// 保存图片
export function setStyleSaveOrUpdate (data) {
  return request({
    url: '/style/saveOrUpdate',
    method: 'post',
    data
  })
}

// 获取税类编码树
export function getCommodityTreeselect (data) {
  return request({
    url: '/tax-classify-code/list',
    method: 'post',
    data
  })
}
// 增税类编码树
export function setCommoditySaveOrUpdate (data) {
  return request({
    url: '/tax-classify-code/saveOrUpdate',
    method: 'post',
    data
  })
}
// 删税类编码树
export function setCommodityDelete (data) {
  return request({
    url: '/tax-classify-code/delete',
    method: 'post',
    data
  })
}

// 同步税类编码树
export function setCommodityTreeselectSync (data) {
  return request({
    url: '/commodity-info/sync',
    method: 'post',
    data
  })
}

// 获取自动开票产品
export function getAutoBillProductLIst (data) {
  return request({
    url: '/auto-bill-product/list',
    method: 'post',
    data
  })
}

// 新增自动开票产品
export function setAutoBillProductSaveOrUpdate (data) {
  return request({
    url: '/auto-bill-product/saveOrUpdate',
    method: 'post',
    data
  })
}
// 删除自动开票产品
export function setAutoBillProductDelete (data) {
  return request({
    url: '/auto-bill-product/delete',
    method: 'post',
    data
  })
}

// 自动开票产品详情
export function getAutoBillProductGet (data) {
  return request({
    url: '/auto-bill-product/get',
    method: 'post',
    data
  })
}

//图片处理
export function handleImage (data) {
  return request({
    url: '/file-upload/get',
    method: 'post',
    data
  })
}
//新增地址
export function addressAdd (data) {
  return request({
    url: '/address/saveOrUpdate',
    method: 'post',
    data
  })
}
//地址列表
export function addressList (data) {
  return request({
    url: '/address/listByUserId',
    method: 'post',
    data
  })
}
//地址列表
export function warehouseAddressList (data) {
  return request({
    url: '/address/list',
    method: 'post',
    data
  })
}
//地址详情
export function addressInfo (data) {
  return request({
    url: '/address/get',
    method: 'post',
    data
  })
}
//删除地址
export function addressDel (data) {
  return request({
    url: '/address/delete',
    method: 'post',
    data
  })
}
//全部公司主体列表
export function supplierAllList (data) {
  return request({
    url: '/supplier/all',
    method: 'post',
    data
  })
}
// 全部公司主体列表 自己公司(晨链、壹家)
export function getCompanyInfo (data) {
  return request({
    url: '/company-base/getCompanyInfo',
    method: 'post',
    data
  })
}

// 定时任务- 列表
export function getJobList (data) {
  return request({
    url: '/admin/job/query',
    method: 'post',
    data
  })
}
// 定时任务- 创建
export function createJob (data) {
  return request({
    url: '/admin/job/add',
    method: 'post',
    data
  })
}
// 定时任务- 删除
export function deleteJob (data) {
  return request({
    url: '/admin/job/delete',
    method: 'post',
    data
  })
}
// 定时任务- 暂停
export function pauseJob (data) {
  return request({
    url: '/admin/job/pause',
    method: 'post',
    data
  })
}
// 定时任务- 重启
export function resumeJob (data) {
  return request({
    url: '/admin/job/resume',
    method: 'post',
    data
  })
}
// 定时任务- 更新
export function updateJob (data) {
  return request({
    url: '/admin/job/reschedule',
    method: 'post',
    data
  })
}

// 定时任务- 手动
export function runJob (data) {
  return request({
    url: '/admin/job/run',
    method: 'post',
    data
  })
}
//
export function sysOperLogList (data) {
  return request({
    url: '/sys/log/list',
    method: 'post',
    data
  })
}
